export const TRACK_VALIDATION_ERROR = 'PAYMENTS/TRACKING/VALIDATION_ERROR';

// the reducer for this action calls logs error
export const trackValidationError = (data: any) => ({
  type: TRACK_VALIDATION_ERROR,
  payload: {
    data,
  },
});
